import axios from '@/config/axios';

const state = {
    products: null,
    featured: null,
    singleProduct: '',
    errors: null,
    message: null,
    productEnquiryStatus: null,
    searchProducts: [],
    productNames: []
};

const getters = {
    getProducts: state => state.products,
    getFeatured: state => state.featured,
    getSingleProduct: state => state.singleProduct,
    getErrors: state => state.errors,
    getMessage: state => state.message,
    getProductEnquiryStatus: state => state.enquiryStatus,
    getSearchProducts: state => state.searchProducts,
    getProductNames: state => state.productNames
};

const mutations = {
    setProducts(state, products) {
        state.products = products;
    },
    setFeatured(state, featured) {
        state.featured = featured;
    },
    setSingleProduct(state, singleProduct) {
        state.singleProduct = singleProduct;
    },
    setErrors: (state, errors) => {
        state.errors = errors;
    },
    setMessage: (state, message) => {
        state.message = message;
    },
    setProductEnquiryStatus: (state, status) => {
        state.enquiryStatus = status;
    },
    setSearchProducts: (state, ProductsData) => {
        state.searchProducts = ProductsData;
    },
    setProductNames: (state, productNames) => {
        state.productNames = productNames;
    }
};

const actions = {
    // fetchProductNames: async (context, params) => {
    //     try {
    //         context.commit('products/setProductNames', null, { root: true });
    //         let response = await axios.get('/products/' + params.category + '?page=' + params.page);
    //         context.commit('products/setProductNames', response.data.products, { root: true });
    //     } catch (error) {
    //         context.commit('products/setErrors', error.response, { root: true });
    //     }
    // },
    fetchByCategory: async (context, params) => {
        try {
            context.commit('products/setProducts', null, {root: true});
            let response = {}
            if (params.order) {
                response = await axios.get('/products/' + params.category + '?order=' + params.order + '&sort=' + params.sort + '&page=' + params.page);
            } else {
                response = await axios.get('/products/' + params.category + '?page=' + params.page);
            }
            context.commit('products/setProducts', response.data.products, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
            context.commit('products/setErrors', error.response, {root: true});
        }
    },
    fetchProducts: async (context, params) => {
        try {
            context.commit('products/setProducts', null, {root: true});
            let response = {};
            if (params.name) {
                response = await axios.get('/products?page=' + params);
            } else {
                response = await axios.get('/products?page=' + params);
            }
            context.commit('products/setProducts', response.data.products, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
            context.commit('products/setErrors', error.response, {root: true});
        }
    },
    fetchSingleProduct: async (context, slug) => {
        try {
            context.commit('products/setSingleProduct', null, {root: true});
            let response = await axios.get('products/show/' + slug);
            context.commit('products/setSingleProduct', response.data.product, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    featuredProducts: async (context) => {
        try {
            context.commit('products/setFeatured', null, {root: true});
            let response = await axios.get('/featured');
            context.commit('products/setFeatured', response.data.products, {root: true});
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
            context.commit('products/setErrors', error.response, {root: true});
        }
    },
    placeProductEnquiry: async ({commit, dispatch}, params) => {
        try {
            commit('products/setProductEnquiryStatus', null, {root: true});
            dispatch('errors/clear', null, {root: true});
            let response = await axios.post('/product-enquiry', params);
            commit('errors/setMessage', response.data.message, {root: true});
        } catch (error) {
            dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    searchByQuery: async ({commit, dispatch}, params) => {
        try {
            commit('products/setProductNames', null, {root: true});
            dispatch('errors/clear', null, {root: true});
            let response = await axios.get('/search?q=' + params.search_query);
            commit('products/setProductNames', response.data.products, {root: true});
        } catch (error) {
            dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    search: async ({commit, dispatch}, params) => {
        try {
            commit('products/setSearchProducts', null, {root: true});
            dispatch('errors/clear', null, {root: true});
            let response = null;
            let url = '/search/brand=';
            if (params.type === 'products') {
                url = '/search?products=';
            }
            response = await axios.get(url + params.query + '&page=' + (params.page || 1) + '&order=' + (params.order || '') + '&sort=' + (params.sort || ''));
            commit('products/setSearchProducts', response.data.products, {root: true});

        } catch (error) {
            dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
